import AppManagerClient from '../../api/AppManagerClient';
import { IManagingWindowsServiceInstance } from '../../api/models';
import React, { useEffect } from 'react';
import { WindowsServiceInstallInfoView } from './WindowsServiceInstallInfoView';
import { Merger } from '../../helpers/Merger';

export const WindowsServiceInstallInfo = (props: any) => {
    const [serverApps, setServerApps]: [IManagingWindowsServiceInstance[], Function] = React.useState([]);
    const [isLoading, setLoadingStatus] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getWindowsServiceForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <WindowsServiceInstallInfoView
            serverApps={Merger.merge(serverApps)}
            isLoading={isLoading}
            errorMessage={errorMessage}
            isDataNotFound={serverApps.length === 0}
            applicationName={applicationName}
        />
    );
};
